import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar, FiTrendingUp, FiZap, FiTarget } = FiIcons;

function ScoreDisplay({ score, accuracy, level, streak }) {
  const stats = [
    { label: 'Score', value: score.toLocaleString(), icon: FiStar, color: 'text-yellow-400' },
    { label: 'Level', value: level, icon: FiTrendingUp, color: 'text-blue-400' },
    { label: 'Streak', value: streak, icon: FiZap, color: 'text-purple-400' },
    { label: 'Accuracy', value: `${accuracy.toFixed(1)}%`, icon: FiTarget, color: 'text-green-400' }
  ];

  return (
    <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 mb-6">
      <div className="grid grid-cols-2 gap-4">
        {stats.map((stat, index) => (
          <motion.div
            key={stat.label}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
            className="text-center"
          >
            <div className="flex items-center justify-center gap-2 mb-1">
              <SafeIcon icon={stat.icon} className={`${stat.color} text-sm`} />
              <span className="text-gray-300 text-sm">{stat.label}</span>
            </div>
            <div className="text-white font-bold text-lg">
              {stat.value}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default ScoreDisplay;